
export class ReportProfileAlertBaseModel {
  providerId: string;
  providerInstanceId: string;
  adminObjectId: string;
  endDate: Date;
  comments: string;
  sendNotificationDirectUser: boolean;
}
